import { Triggers } from '../../../js/triggers'

const triggers = new Triggers()

export default triggers
